import { FormattedEvent } from '@eventbrite/event-renderer';

const EXPERIMENT_TEST_TAG = 'eb_ads_layout_v3_ab_test:test';

/**
 * Check if any promoted event has the test group experiment tag.
 * Tags are set by ads-retrieval based on Statsig experiment assignment
 * Experiment link: https://console.statsig.com/7n3hq8N8FgwqPLIkQ9P62X/experiments/eb_ads_layout_v3_ab_test/setup
 * Backend only tags events when app=web AND isMobileWeb=true.
 */
export const checkIsTestGroup = (events: FormattedEvent[]): boolean =>
    events.some((event) =>
        event.promotedListingMetadata?.experiments?.includes(
            EXPERIMENT_TEST_TAG,
        ),
    );
